module.exports = __webpack_public_path__ + "img/career-capital.cf3420e0.svg";